const STYLE_TAG_ID = "wixar-lighthouse-overrides";

const CHAT_ICON_DATA_URI =
  "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23ffffff' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z'/%3E%3C/svg%3E";

const PANEL_CSS = `
.LighthouseTitle span[style*="float"] {
  background-color: #00c889 !important;
  color: #ffffff !important;
  border-radius: 0.5rem !important;
  font-weight: 500 !important;
  padding: 6px 12px 6px 34px !important;
  background-image: url("${CHAT_ICON_DATA_URI}") !important;
  background-repeat: no-repeat !important;
  background-position: 12px center !important;
  background-size: 16px 16px !important;
  transition: background-color 150ms ease !important;
}
.LighthouseTitle span[style*="float"]:hover {
  background-color: #00b47b !important;
}
`;

function tryInjectAll(): boolean {
  let panelStyled = false;
  document.querySelectorAll<HTMLIFrameElement>("#lighthouse iframe").forEach((frame) => {
    const doc = frame.contentDocument;
    if (!doc?.head) {
      return;
    }
    if (!doc.getElementById(STYLE_TAG_ID)) {
      const style = doc.createElement("style");
      style.id = STYLE_TAG_ID;
      style.textContent = PANEL_CSS;
      doc.head.appendChild(style);
    }
    if (frame.id === "MainFrame") {
      panelStyled = true;
    }
  });
  return panelStyled;
}

let loopActive = false;

export function injectLighthousePanelStyles() {
  if (typeof window === "undefined" || loopActive) {
    return;
  }
  loopActive = true;
  let attempts = 0;
  const tick = () => {
    attempts += 1;
    if (tryInjectAll() || attempts >= 20) {
      loopActive = false;
      return;
    }
    setTimeout(tick, 200);
  };
  tick();
}
